import { GameVars } from "../GameVars";
import { GameManager } from "../GameManager"; 
import { GameConstants } from "../GameConstants";
import { Game } from "../Game";

export class BootScene extends Phaser.Scene {

    public static currentInstance: BootScene;

    public static onOrientationChange(): void {

        GameVars.currentScene.time.addEvent({ delay: 100, callback: () => { 

            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            Game.currentInstance.scale.refresh();

            GameVars.aspectRatio = window.innerWidth / window.innerHeight;
            GameVars.contrascaleX = (GameVars.aspectRatio - (4 / 3)) * .2;

            if (window.innerHeight > window.innerWidth) {
                GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
                GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);

            } else {
                GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
                GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);
            }

        }, callbackScope: GameVars.currentScene});
    }
    
    constructor() {

        super("BootScene");
    }

    public preload(): void {

        this.load.image("preload_surfer", "assets/surfer_king_preloader.png");
    }

    public create(): void {

        this.add.text(-100, -100, "abcdefg", { fontFamily: "Rubik-Light", fontSize: 28, color: "#A6F834" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Rubik-Regular", fontSize: 28, color: "#A6F834" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Rubik-Medium", fontSize: 28, color: "#A6F834" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Rubik-Bold", fontSize: 28, color: "#A6F834" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Dalek", fontSize: 28, color: "#A6F834" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Lithos", fontSize: 28, color: "#A6F834" });

        BootScene.currentInstance = this;
        GameManager.setCurrentScene(this);

        if (this.sys.game.device.os.desktop) {

            GameVars.scaleX = 1;
            GameVars.scaleY = 1;

            GameVars.aspectRatio = window.innerWidth / window.innerHeight;
            GameVars.contrascaleX = (GameVars.aspectRatio - (4 / 3)) * .2;

        } else {

            BootScene.currentInstance.game.scale.displaySize = BootScene.currentInstance.game.scale.parentSize;
            BootScene.currentInstance.game.scale.refresh();

            GameVars.aspectRatio = window.innerWidth / window.innerHeight;
            GameVars.contrascaleX = (GameVars.aspectRatio - (4 / 3)) * .2;

            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
            GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / (window.innerHeight / window.innerWidth);

            this.game.scale.on("orientationchange", BootScene.onOrientationChange, BootScene.currentInstance);
        }

        this.scene.setVisible(false);

        GameManager.init();
    }
}
